/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImageCustom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v10.757l-1.879-1.878c-.04-.04-.08-.078-.121-.115V4H4v16h6v2H2V3zm14 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm5.707 5.293-3-3a1 1 0 0 0-1.414 0l-5 5-.293.293V22h4.414l.293-.293 5-5a1 1 0 0 0 0-1.414zM14 20v-1.586l4-4L19.586 16l-4 4zm-2.466-4.777L10 16.757V19H5l4-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgImageCustom as ImageCustom };
